export default __webpack_public_path__ + "static/media/facebook_color.3a53631c.svg";